import queryString from 'query-string';

export const DELIVERY_METHOD = {
  FRIDGE: 'PREORDER_BOT',
  DELIVERY: 'DELIVERY_BOT',
};

const getAppropriatePriceByRules = (rules = [], itemCount) => {
  if (rules.length === 0) return 0;

  const sortedRules = rules.sort((rule1, rule2) => (
    parseInt(rule1.limit, 10) > parseInt(rule2.limit, 10) ? 1 : -1));

  return sortedRules.reduce((result, rule) => {
    if (itemCount < rule.limit) return result;
    return parseInt(rule.price, 10);
  }, parseInt(sortedRules[0].price, 10));
};

const getAvailableLocation = ({ defaultLocation = [], availableLocationSymbolStrings = [] }) => {
  if (!availableLocationSymbolStrings || availableLocationSymbolStrings.length === 0) return {};
  const matchingRuleRegxs = availableLocationSymbolStrings
    .map((availableLocationSymbolString) => availableLocationSymbolString
      .split(',')
      .map((location) => {
        const regx = new RegExp(`^${
          (location || '')
            .split('*')
            .map((str) => str.replace(/([.*+?^=!:${}()|[]\/\\])/g, '\\$1'))
            .join('.*')
        }$`);
        return regx;
      }, {}));

  const result = {};

  defaultLocation.forEach((locationString) => {
    let passedPhase2 = true;
    matchingRuleRegxs.forEach((matchingRuleRegx) => {
      if (!passedPhase2) return;
      let passedPhase1 = false;
      matchingRuleRegx.forEach((regx) => {
        if (!passedPhase1 && regx.test(locationString)) {
          passedPhase1 = true;
        }
      });
      if (!passedPhase1) passedPhase2 = false;
    });
    if (passedPhase2) {
      const [city, district] = locationString.split('/');
      result[city] = {
        ...(result[city] || {}),
        [district]: district,
      };
    }
  });
  return result;
};

// eslint-disable-next-line
const getRebatePercentage = (originPrice, salePrice) => Math.round(((originPrice - salePrice) / originPrice) * 100); 

const getBasePrice = (preOrder) => (Object.keys(preOrder?.hierarchyPriceRules || {}).length > 0
  ? preOrder?.hierarchyPriceRules[0].price : preOrder?.price) || 0;

const calculateDeliveryFee = (checkoutData = {}) => {
  let deliveryFee = 0;
  const groupByDeliveryData = {};
  Object.keys(checkoutData).forEach((preOrderId) => {
    const {
      amount,
      fridgeId,
      deliveryFeeRules,
      date,
      timeSlot,
      provider,
    } = checkoutData[preOrderId];
    if (fridgeId !== DELIVERY_METHOD.DELIVERY) return;
    if (!(amount > 0)) return;
    if (!deliveryFeeRules) return;
    const key = `${date}_${timeSlot}_${provider}`;
    groupByDeliveryData[key] = {
      ...(groupByDeliveryData[key] || {}),
      deliveryFeeRules,
      amount: ((groupByDeliveryData[key] || {}).amount || 0) + amount,
    };
  });
  Object.keys(groupByDeliveryData).forEach((key) => {
    const {
      deliveryFeeRules,
      amount,
    } = groupByDeliveryData[key];
    deliveryFee += getAppropriatePriceByRules(deliveryFeeRules, amount);
  });
  return deliveryFee;
};

const getUTMQueryStringFromLocalStorage = () => {
  try {
    const utmInfo = localStorage.getItem('utmInfo') || '{}';
    const utmQueryString = queryString.stringify(JSON.parse(utmInfo));

    return utmQueryString;
  } catch (e) {
    console.log(e.message);
    return '';
  }
};

const genRedirectUrlWithTrackingInfo = (redirectUrl, eventName) => {
  const redirectUrlComponent = new URL(redirectUrl);
  const { searchParams } = redirectUrlComponent;
  const utmInfo = JSON.parse(localStorage.getItem('utmInfo') || '{}');

  if (eventName) searchParams.set('eventName', eventName);

  Object.entries(utmInfo).forEach(([key, value]) => {
    if (value) searchParams.set(key, value);
  });

  try {
    // eslint-disable-next-line no-undef
    searchParams.set('clientId', ga.getAll()[0].get('clientId'));
  } catch (e) {
    console.log(e.message);
  }

  try {
    // eslint-disable-next-line no-undef
    searchParams.set('distinctId', mixpanel.get_distinct_id());
  } catch (e) {
    console.log(e.message);
  }

  return redirectUrlComponent.toString();
};

export default {
  getAppropriatePriceByRules,
  getAvailableLocation,
  getRebatePercentage,
  getBasePrice,
  calculateDeliveryFee,
  getUTMQueryStringFromLocalStorage,
  genRedirectUrlWithTrackingInfo,
};
